import { useState, useRef } from 'react';
import InterestModal from './InterestModal';

export default function PartnershipCTA() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  const handleOpenModal = () => {
    // Scroll section to center of viewport smoothly
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect();
      const sectionCenter = rect.top + rect.height / 2;
      const viewportCenter = window.innerHeight / 2;
      const scrollTo = window.scrollY + sectionCenter - viewportCenter;
      
      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth'
      });

      // Open modal after scroll animation
      setTimeout(() => {
        setIsModalOpen(true);
      }, 300);
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-br from-[#FF6B6B] via-[#FF8E53] to-[#FFA07A] text-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-8">
            <i className="ri-hand-heart-line text-5xl"></i>
          </div>

          {/* Heading */}
          <h2 className="text-4xl lg:text-6xl font-bold mb-6" style={{ lineHeight: '1.75' }}>
            استثمار استراتيجي في المواهب والابتكار والمستقبل
          </h2>

          {/* Description */}
          <p className="text-xl lg:text-2xl mb-10 leading-relaxed text-white/90">
            انضم إلينا في بناء الجيل القادم من المبتكرين والقادة. شراكتك تخلق تأثيراً دائماً.
          </p>

          {/* CTA Button */}
          <button 
            onClick={handleOpenModal}
            className="bg-white text-[#FF6B6B] px-10 py-5 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span>ابدأ الشراكة</span>
            <i className="ri-arrow-left-line"></i>
          </button>

          {/* Additional Info */}
          <div className="mt-12 pt-8 border-t border-white/30">
            <p className="text-white/80 text-lg">
              هل لديك أسئلة؟ تواصل معنا على{' '}
              <a href="mailto:info@dfy.org.sa" className="underline hover:text-white transition-colors">
                info@dfy.org.sa
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Interest Modal */}
      <InterestModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        projectName="مساحة شباب - شراكة استراتيجية"
      />
    </section>
  );
}
